import { NotifyErrorCustomBase } from "../../components/Base/NotifyCustom";
import { notify, notifyError } from "../notify";

export class ErrorCustomFetch extends Error {
  error_name: string;
  error_msg_front: string;
  error_msg_console: string;
  error_msg_sequence: string;
  typeNotify: string | undefined;
  ignoring: boolean;
  console_error: boolean;
  res: { [key: string]: any } | undefined;
  id_any: string | undefined;

  constructor(
    error_name: string,
    error_msg_front: string,
    error_msg_console: string,
    error_msg_sequence: string,
    typeNotify: string | undefined,
    ignoring: boolean,
    console_error: boolean,
    res?: { [key: string]: any },
    id_any?: string
  ) {
    super(error_msg_front);
    this.error_name = error_name;
    this.error_msg_front = error_msg_front;
    this.error_msg_console = error_msg_console;
    this.error_msg_sequence = error_msg_sequence;
    this.typeNotify = typeNotify;
    this.ignoring = ignoring;
    this.console_error = console_error;
    this.res = res;
    this.id_any = id_any;
    if (this.ignoring === false && this.typeNotify !== undefined) {
      if (this.typeNotify === "notifyError") {
        if (this.id_any) {
          notifyError(
            NotifyErrorCustomBase(this.error_msg_front, this.id_any),
            5000,
            {
              toastId: "notify-lot",
            }
          );
        } else {
          notifyError(this.error_msg_front, 5000, { toastId: "notify-lot" });
        }
      } else if (this.typeNotify === "notify") {
        notify(this.error_msg_front);
      }
    }
    if (console_error === true) {
      const name_console_error = this.error_msg_front.split(":");
      console.error(name_console_error[0], {
        "Error Name": error_name,
        "Error Pdp": this.error_msg_front,
        "Error Sequence": this.error_msg_sequence,
        "Error Console": `${this.error_msg_console}`,
      });
    }
  }
}

export class ErrorCustomFetchCode extends ErrorCustomFetch {
  constructor(
    error_msg_front: string,
    error_msg_console: string,
    error_msg_sequence: string,
    typeNotify: string = "notifyError",
    ignoring: boolean = false,
    console_error: boolean = true
  ) {
    super(
      "ErrorCustomFetchCode",
      error_msg_front,
      error_msg_console,
      error_msg_sequence,
      typeNotify,
      ignoring,
      console_error
    );
  }
}

export class ErrorCustomTimeout extends ErrorCustomFetch {
  constructor(
    error_name: string,
    error_msg_front: string,
    error_msg_console: string,
    error_msg_sequence: string,
    typeNotify: string = "notifyError",
    ignoring: boolean = false,
    console_error: boolean = true,
    res?: { [key: string]: any },
    id_any?: string
  ) {
    super(
      error_name,
      error_msg_front,
      error_msg_console,
      error_msg_sequence,
      typeNotify,
      ignoring,
      console_error,
      res,
      id_any
    );
  }
}

export class ErrorCustomFetchTimeout extends ErrorCustomTimeout {
  constructor(
    error_msg_front: string,
    error_msg_console: string,
    error_msg_sequence: string,
    typeNotify: string = "notifyError",
    ignoring: boolean = false,
    console_error: boolean = true,
    res?: { [key: string]: any },
    id_any?: string
  ) {
    super(
      "ErrorCustomFetchTimeout",
      error_msg_front,
      error_msg_console,
      error_msg_sequence,
      typeNotify,
      ignoring,
      console_error,
      res,
      id_any
    );
  }
}

export class ErrorCustomApiGateway extends ErrorCustomFetch {
  constructor(
    error_msg_front: string,
    error_msg_console: string,
    error_msg_sequence: string,
    typeNotify: string = "notifyError",
    ignoring: boolean = false,
    console_error: boolean = true,
    id_any?: string
  ) {
    super(
      "ErrorCustomApiGateway",
      error_msg_front,
      error_msg_console,
      error_msg_sequence,
      typeNotify,
      ignoring,
      console_error,
      undefined,
      id_any
    );
  }
}

export class ErrorCustomApiGatewayTimeout extends ErrorCustomTimeout {
  constructor(
    error_msg_front: string,
    error_msg_console: string,
    error_msg_sequence: string,
    typeNotify: string = "notifyError",
    ignoring: boolean = false,
    console_error: boolean = true,
    id_any?: string
  ) {
    super(
      "ErrorCustomApiGatewayTimeout",
      error_msg_front,
      error_msg_console,
      error_msg_sequence,
      typeNotify,
      ignoring,
      console_error,
      undefined,
      id_any
    );
  }
}

export class ErrorCustomBackend extends ErrorCustomFetch {
  constructor(
    error_name: string | undefined,
    error_msg_front: string,
    error_msg_console: string,
    error_msg_sequence: string,
    typeNotify: string = "notifyError",
    ignoring: boolean = false,
    console_error: boolean = true,
    res?: { [key: string]: any },
    id_any?: string
  ) {
    super(
      error_name ? error_name : "ErrorCustomBackend",
      error_msg_front,
      error_msg_console,
      error_msg_sequence,
      typeNotify,
      ignoring,
      console_error,
      res,
      id_any
    );
  }
}

export class ErrorCustomBackendUser extends ErrorCustomBackend {
  constructor(
    error_msg_front: string = "desconocido",
    error_msg_console: string = "desconocido",
    error_msg_sequence: string = "desconocido",
    typeNotify: string | undefined = "notify",
    ignoring: boolean = false,
    console_error: boolean = true,
    res?: { [key: string]: any },
    id_any?: string
  ) {
    super(
      "ErrorCustomBackendUser",
      error_msg_front,
      error_msg_console,
      error_msg_sequence,
      typeNotify,
      ignoring,
      console_error,
      res,
      id_any
    );
  }
}

export class ErrorCustomBackendPending extends ErrorCustomTimeout {
  constructor(
    error_msg_front: string,
    error_msg_console: string,
    error_msg_sequence: string,
    typeNotify: string = "notifyError",
    ignoring: boolean = false,
    console_error: boolean = true,
    res?: { [key: string]: any },
    id_any?: string
  ) {
    super(
      "ErrorCustomBackendPending",
      error_msg_front,
      error_msg_console,
      error_msg_sequence,
      typeNotify,
      ignoring,
      console_error,
      res,
      id_any
    );
  }
}

export class ErrorCustomBackendRechazada extends ErrorCustomBackend {
  constructor(
    error_msg_front: string,
    error_msg_console: string,
    error_msg_sequence: string,
    typeNotify: string = "notifyError",
    ignoring: boolean = false,
    console_error: boolean = true,
    res?: { [key: string]: any },
    id_any?: string
  ) {
    super(
      "ErrorCustomBackendRechazada",
      error_msg_front,
      error_msg_console,
      error_msg_sequence,
      typeNotify,
      ignoring,
      console_error,
      res,
      id_any
    );
  }
}

export class ErrorCustomBackendXData<T> extends ErrorCustomFetch {
  error_origin: ErrorCustomFetch;
  data: T;

  constructor(
    error_msg: string,
    error_origin: ErrorCustomFetch,
    id_any: string,
    data: T
  ) {
    super(
      error_origin.error_name,
      error_msg,
      error_origin.error_msg_console,
      error_origin.error_msg_sequence,
      error_origin.typeNotify,
      error_origin.ignoring,
      error_origin.console_error,
      error_origin.res,
      id_any
    );
    this.error_origin = error_origin;
    this.data = data;
  }
}
export class ErrorCustomUseHookCode extends ErrorCustomFetch {
  constructor(
    error_msg_front: string,
    error_msg_console: string,
    error_msg_sequence: string,
    typeNotify: string = "notifyError",
    ignoring: boolean = false,
    console_error: boolean = true,
    id_any?: string
  ) {
    super(
      "ErrorCustomUseHookCode",
      error_msg_front,
      error_msg_console,
      error_msg_sequence,
      typeNotify,
      ignoring,
      console_error,
      undefined,
      id_any
    );
  }
}

export class ErrorCustomComponentCode extends ErrorCustomFetch {
  constructor(
    error_msg_front: string,
    error_msg_console: string,
    error_msg_sequence: string,
    typeNotify: string = "notifyError",
    ignoring: boolean = false,
    console_error: boolean = true,
    id_any?: string
  ) {
    super(
      "ErrorCustomComponenteCode",
      error_msg_front,
      error_msg_console,
      error_msg_sequence,
      typeNotify,
      ignoring,
      console_error,
      undefined,
      id_any
    );
  }
}

export class ErrorCustomRaise extends ErrorCustomFetch {
  constructor(
    error_msg_front: string,
    error_msg_console: string,
    error_msg_sequence: string,
    typeNotify: string = "notifyError",
    ignoring: boolean = false,
    console_error: boolean = true
  ) {
    super(
      "ErrorCustomRaise",
      error_msg_front,
      error_msg_console,
      error_msg_sequence,
      typeNotify,
      ignoring,
      console_error
    );
  }
}
